import React from 'react';
import { StatsCards } from '@/widgets/stats-cards';
import { PhoneboardList } from '@/widgets/phoneboard-list';
import { WorkLogWidget } from '@/widgets/work-log';

export const DashboardPage: React.FC = () => {
  return (
    <div className="space-y-8">
      {/* Stats Cards */}
      <StatsCards />

      {/* Phoneboard Management */}
      <PhoneboardList />

      {/* Work Log */}
      <WorkLogWidget />
    </div>
  );
};